import anime from 'animejs/lib/anime.es.js';
import scrollama from 'scrollama';

// instantiate the scrollama
const scroller = scrollama();



// setup the instance, pass callback functions
scroller
    .setup({
        step: '.js-section',
        debug: false,
        once: true,
        offset: 0.75,
    })
    .onStepEnter(response => {
        anime({
            targets: response.element.querySelectorAll(
                '.js-animate-transform-bottom',
            ),
            translateY: [100, 0],
            // translateZ: 0,
            opacity: [0, 1],
            easing: 'easeOutExpo',
            duration: 1000,
            delay: (el, i) => 300 + 30 * i,
        });

        anime({
            targets: response.element.querySelectorAll(
                '.js-animate-transform-right',
            ),
            translateX: [100, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: 'easeOutExpo',
            duration: 1000,
            delay: (el, i) => 300 + 30 * i,
        });

        anime({
            targets: response.element.querySelectorAll(
                '.js-animate-transform-left',
            ),
            translateX: [-100, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: 'easeOutExpo',
            duration: 1000,
            delay: (el, i) => 300 + 30 * i,
        });

        anime({
            targets: response.element.querySelectorAll(
                '.js-animate-transform-stagger',
            ),
            scale: [
                { value: 0, easing: 'linear', duration: 0 },
                { value: 1, easing: 'easeInOutQuad', duration: 250 },
            ],
            delay: anime.stagger(150),
        });

    })
    .onStepExit(() => {
        // { element, index, direction }
    });

// setup resize event
window.addEventListener('resize', scroller.resize);
